<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container modal-container-sm object-modal-container email-modal-container border-black">
          <div class="modal-header">
            <h3>Get help by email</h3>
            <button class="close btn  btn-light pull-right" @click="$emit('close')"><i class="fa fa-close"></i></button>
          </div>
          <div class="modal-body">
            <div v-if="!success && error.general" :class="'alert alert-error'">
              <span v-html="error.general"></span>
            </div>
            <div v-else-if="success && message" :class="'alert alert-success'">
              <span v-html="message"></span>
            </div>
            <div></div>
            <form ref="form">
              <div class="row">
                <div class="col-xs-12">
                  <label>Your Name*</label>
                  <input :class="{'input-error': (error.name ? true : false)}" name="name" type="text" v-model="form.name" @input="error.name = null" required />
                  <span class="input-error-msg" v-if="error.name ? true : false"> {{error.name}} </span>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <label>Your Email Address*</label>
                  <input :class="{ 'input-error': (error.email ? true : false) }" name="email" type="email" v-model="form.email" @input="error.email = null" required />
                  <span class="input-error-msg" v-if="error.email ? true : false"> {{error.email}} </span>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <label>Citation*</label>
                  <textarea :class="{ 'input-error': (error.citation ? true : false) }" name="citation" id="citation" type="text" v-model="form.citation" required readonly rows="10" />
                  <span class="input-error-msg" v-if="error.citation ? true : false"> {{error.citation}} </span>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <label>Message*</label>
                  <textarea :class="{ 'input-error': (error.message ? true : false) }" name="message" v-model="form.message" placeholder="Comment" @input="error.message = null" required></textarea>
                  <span class="input-error-msg" v-if="error.message ? true : false"> {{error.message}} </span>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <label for="g-recaptcha" >Captcha*</label>
                   <div id="g-recaptcha" class="g-recaptcha" :data-sitekey="recaptcha_key"></div>
                </div>
              </div>
              <input type="hidden" name="origin" v-model="form.origin" required>
            </form>
          </div>
          <div class="modal-footer">
            <button class="btn  btn-dark" v-on:click="handleSubmitClick">Submit</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>  
  export default {
    data: function () {
      let citation = require('../../../citation.js');
      return {
        success: null,
        message: '',
        recaptcha_key:app_recaptcha_sitekey,
        form: {
          citation: citation.retrieveCitation(),
          name: '',
          email: '',
          message: '',
          origin: 'object_help'
        },
        error: {},
      };
    },
    mounted() {
      try{
        grecaptcha.render('g-recaptcha'); // 'g-recaptcha' is the id that was assigned to the widget
      } catch(e) {
        console.error(e);
      }
    },

    methods: {

      submit: function () {
        //add recaptcha reponse
        this.$data.form['g-recaptcha-response']=grecaptcha.getResponse();

        return fetch('/contact', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          mode: 'same-origin',
          body: JSON.stringify(this.$data.form)
        }).then((response) => response.json())
          .then((response) => {
            if (response.error) {
              return Promise.reject(response.error);
            }
            return response;
          })
          .then((data) => {
            this.$data.success = true;
            this.$data.message = 'Your email has been successfully <strong>submitted</strong>';
            setTimeout(function () {
              location.reload();
            }, 2000);
          }).catch((err) => {
            this.$data.success = false;
            this.$data.error = Object.assign({},JSON.parse(err));
          });
      },
      handleSubmitClick: function () {
        const form = this.$refs.form;

        if (form.checkValidity()) {
          this.submit();
        } else {
          // Invalid form
          if (form.reportValidity) {
            form.reportValidity();
          } else {
            // For IE
            let errors = {};

            for (const el of form.elements) {
              if (el.validationMessage) {
                errors[el.getAttribute('name')] = el.validationMessage;
              }
            }

            this.$data.error = errors;
          }
        }
      }
    }
  }
</script>
